export default __webpack_public_path__ + "static/pixel-rectangle-1c69940837bc5f2852283c7d593ea635.svg";